module.exports = __webpack_public_path__ + "static/img/img5.6b2e0f0a.png";